import React, { useEffect, useState } from "react";
import $ from "jquery";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import JobsDetail from "../JobsDetail";
import { report_For, timeout_for_data_tables, TransferTypes, no_of_rows_on_single_page } from "../../constants/enums";
import { format, parseISO } from 'date-fns'


function WarehouseandPartTotalReportListing({filteredValues}) {

  //console.log("vals", filteredValues);
    useEffect(() => {
     // const timeout = setTimeout(() => {
            $("#WarehouseandPartTotalReport").DataTable({
                              responsive: true,
                              pageLength: no_of_rows_on_single_page,
                              destroy: true,
                              columnDefs: [
                                  { responsivePriority: 1, targets: 0 },
                                  { responsivePriority: 2, targets: -1 },
                              ],
                              dom:
                                  "<'row mb-3'<'col-sm-12 col-md-6 d-flex align-items-center justify-content-start'f><'col-sm-12 col-md-6 d-flex align-items-center justify-content-end'B>>" +
                                  "<'row'<'col-sm-12'tr>>" +
                                  "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                              buttons: [
                                  {
                                      extend: "csvHtml5",
                                      text: "CSV",
                                      titleAttr: "Generate CSV",
                                      className: "btn btn-sm btn-primary mr-2",
                                  },
                                  {
                                      extend: "copyHtml5",
                                      text: "Copy",
                                      titleAttr: "Copy to clipboard",
                                      className: "btn btn-sm btn-light",
                                  },
                              ],
                          });
                   //     }, 500);

                     //   return () => clearTimeout(timeout);
    });


    return (
        <>
            {/* Warehouse and Part Total Report */}
            <div className="card card-custom mb-5">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="mb-0">
                            <img src="/media/svg/custom/search.svg" width="30" height="30" className="mr-3" alt="summary" />
                            Warehouse and Part Total Report
                        </h3>
                    </div>
                    <div className="card-toolbar">  </div>
                </div>
                <div className="card-body">
                    <table id="WarehouseandPartTotalReport" className="table table-bordered table-hover table-striped table-sm w-100">
                        <thead>
                            <tr>
                                <th> <i className="fa fa-home mr-1"></i> Warehouse</th>
                                <th><i className="fa fa-list-ul mr-1"></i> PartNum</th>
                                <th> <i className="fa fa-chart-pie mr-1"></i> Total Rec</th>
                                <th>  <i className="fa fa-boxes mr-1"></i> Qty in Warehouse</th>
                                <th><i className="fa fa-boxes mr-1"></i> Qty in Feeders</th>
                                <th> <i className="fa fa-boxes mr-1"></i> Qty in Crew</th>
                                <th> <i className="fa fa-boxes mr-1"></i> Qty Returned From Crew</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filteredValues?.map((el, idx) => {
                                    return(
                                        <tr>
                                            <td>{el?.WAREHOUSE}</td>
                                            <td>{el?.PARTNUM}</td>
                                            <td>{el?.TOTAL_REC}</td>
                                            <td>{el?.QTY_IN_WAREHOUSE}</td>
                                            <td>{el?.QTY_IN_FEEDERS}</td>
                                            <td>{el?.QTY_IN_CREW}</td>
                                            <td>{el?.QTY_RETURNED_FROM_CREW}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div> 
        </>
    );
}

export default WarehouseandPartTotalReportListing;
